module.exports = __webpack_public_path__ + "static/media/celebrate_rejection.bd866211.png";